<div class="container">
  <h1 class="mt120">{{ courseData?.name }}</h1>
  <hr class="mb-0" />
</div>

<div class="mainContnet">
  <div class="container">
    <p>{{ courseData?.description }}</p>

    <div class="row mt-5">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="mx-auto d-table">
          <figure class="book">
            <img
              src="{{ courseData?.imageUrl }}"
              class="img-fluid"
              width="185"
              height="279"
            />
            <figcaption>Student’s Course</figcaption>
          </figure>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="btnCenter">
          <h2 class="text-center">Student’s Course</h2>

          <ng-container *ngIf="!isauth">
            <button
              type="button"
              data-toggle="modal"
              data-target="#exampleModalLong3"
              class="btn btnSecondary mt-2"
            >
              Enroll Online
            </button>
          </ng-container>
          <ng-container *ngIf="isauth">
            <a
              (click)="enrollOnline(courseData?.courseId)"
              *ngIf="
                (bookdetails?.isEnrollOnline == true &&
                  isseminar &&
                  isseminar != null) ||
                (this.courseData?.isSeminarRequired != true && isauth)
              "
              class="btn btnSecondary mt-2"
            >
              <span *ngIf="this.isEnrolled == false">Enroll Online</span>
              <span *ngIf="this.isEnrolled == true">Continue Online</span>
            </a>

            <button
              type="button"
              data-toggle="modal"
              data-target="#exampleModalLong2"
              *ngIf="
                bookdetails?.isEnrollOnline == true &&
                this.courseData?.isSeminarRequired == true &&
                (!isseminar || isseminar == null) &&
                bookdetails?.bookHeading != 'Christianity 101'
              "
              class="btn btnSecondary mt-2"
            >
              Enroll Online
            </button>

            <button
              type="button"
              data-toggle="modal"
              data-target="#exampleModalLong3"
              class="btn btnSecondary mt-2"
              *ngIf="
                bookdetails?.isEnrollOnline == true &&
                bookdetails?.bookHeading == 'Christianity 101' &&
                !isauth
              "
            >
              Enroll Online
            </button>
          </ng-container>

          <a
            *ngIf="
              bookdetails?.isBuyHardCopy == true &&
              isseminar &&
              isseminar != null
            "
            href="{{ bookdetails?.isBuyHardCopyText }}"
            class="btn btnSecondary mt-2"
            >Buy Hardcopy</a
          >
          <button
            type="button"
            data-toggle="modal"
            data-target="#exampleModalLong2"
            *ngIf="
              bookdetails?.isBuyHardCopy == true &&
              (!isseminar || isseminar == null)
            "
            class="btn btnSecondary mt-2"
          >
            Buy Hardcopy
          </button>

          <a
            *ngIf="bookdetails?.isSamplePDF == true"
            href="{{ bookdetails?.isSamplePDFText }}"
            class="btn btnSecondary mt-2"
            >Sample PDF</a
          >
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <div class="mx-auto d-table">
          <h2 class="text-center">Leader’s Guide</h2>
          <div class="d-flex flex-column justify-content-between">
            <a
              *ngIf="
                bookdetails?.isLeaderGuideHardCopy == true &&
                isseminar &&
                isseminar != null
              "
              href="{{ bookdetails?.isLeaderGuideHardCopyText }}"
              class="btn btnSecondary mt-2"
              >Buy Hardcopy</a
            >
            <button
              data-toggle="modal"
              data-target="#exampleModalLong2"
              *ngIf="
                bookdetails?.isLeaderGuideHardCopy == true &&
                (!isseminar || isseminar == null)
              "
              class="btn btnSecondary mt-2"
            >
              Buy Hardcopy
            </button>
            <a
              *ngIf="bookdetails?.isLeaderGuideSmaplePDF == true"
              href="{{ bookdetails?.isLeaderGuideSmaplePDFText }}"
              class="btn btnSecondary mt-2"
              >Sample PDF</a
            >
          </div>
          <p
            *ngIf="bookdetails?.isLeaderGuidButton == true"
            class="text-center"
          >
            A Leader’s Guide is not available. &nbsp;<a
              href="mailto:itim@TrainingInMinistry.com?Subject=Leaders%20Guide"
              >Contact us</a
            >
            for more information.
          </p>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <p class="note"><strong>Note: </strong>{{ courseData?.notes }}</p>
    </div>
  </div>
  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModalLong2"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLong2Title"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header border-0 py-0 pt-0">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          You need to complete the
          <a
            data-dismiss="modal"
            [routerLink]="['/session']"
            style="cursor: pointer"
            >iTIM seminar</a
          >
          to purchase this book
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="exampleModalLong3"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLong2Title"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header border-0 py-0 pt-0">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">You have to be signed into iTIM</div>
      </div>
    </div>
  </div>

  <app-static-footer></app-static-footer>
</div>
